module.exports = __webpack_public_path__ + "media/2-92.4e9c29c1.wav";